module.exports = __webpack_public_path__ + "img/2up.946320e8.png";